window.DASHBOARD_MAP_LEGEND = {
    options: {},
    control: undefined,
    init: function (options) {
        _.extend(window.DASHBOARD_TRACKING_SWITCHER.options, options);

        L.Control.MapLegend = L.Control.extend({
            key: undefined,
            option: {

            },
            onAdd: function (map) {
                var container = L.DomUtil.create('div', 'leaflet-control-tracker-switcher leaflet-bar leaflet-control');
                container.style = "background: white; padding: 5px;";
                var html = [];

                html.push('<table class="drive-waypoint-status-key">');
                _.forEach(window.DASHBOARD_DRIVES._waypointInfo, function (status, statusId) {
                    html.push('<tr>');
                    html.push('<td style="padding-right: 3px; vertical-align: middle">');
                    html.push(`<img src="${status.imgSrc}" style="height: 10px; width: auto;">`);
                    html.push('</td>');
                    html.push('<td>');
                    html.push(status.name);
                    html.push('</td>');
                    html.push('</tr>');
                });
                html.push('</table>');

                container.innerHTML = html.join("");

                return container;
            },

            onRemove: function (map) {

            },

        });

        L.control.MapLegend = function (opts) {
            return new L.Control.MapLegend(opts);
        }

        window.DASHBOARD_MAP_LEGEND.control = L.control.MapLegend({ position: 'bottomleft' });
    },
    showDriveDashboardKey: function () {
        window.DASHBOARD_MAP_LEGEND.control.addTo(window.DASHBOARD_MAP.map);
    },
    hideDriveDashboardKey: function () {
        window.DASHBOARD_MAP_LEGEND.control.remove();
    }
}
